// extracted by mini-css-extract-plugin
export var container = "index-module--container--+MMgw";
export var content = "index-module--content--+X+Cu";
export var head = "index-module--head--tUwAF";
export var parag = "index-module--parag--DFBtq";